import { VerticalSpacer } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled(VerticalSpacer).attrs({
  amount: { small: 16, medium: 16, large: 16 },
})`
  &:not(:first-child) {
    margin-top: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`

export const EmbedWrapper = styled.div`
  position: relative;
  padding-top: 56.65%;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    iframe {
      height: 100% !important;
      width: 100% !important;
    }
  }
`
